module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('section', {
    staticClass: "content",
    attrs: {
      "role": "main",
      "aria-label": "תוכן",
      "id": "RhythmAudition"
    }
  }, [_c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "fill"
  }, [_c('img', {
    key: _vm.img2srcD,
    staticClass: "fillImgFront",
    attrs: {
      "src": "photos/rhythm/pic01.jpg",
      "alt": "איך מצטרפים?"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textbox-bounds textbox-bounds-unbound-double"
  }, [_c('div', {
    staticClass: "textbox-tab-mark"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "origamiform",
      "data-origamiformname": "form_6040df676c37c",
      "data-origamiformid": "f2be2d3fa03eafb5d6ee022c2c4fa7d649e9b7a67718f027da675d1179feef358807fa69235dc3bb5bd5bca8bed0c439b9040bfab13029f041cd075acf94b136Rc+sM89Tjvyjs4O9tsHPvuEEDLgeFvnxc4ugPGObWgD9fY/x3eNLAhwsoofOpdcLIpBShmOR4gIToydUSKNWq+sM3Am23IjkfaZcrDdaw+AtNGqPZO1LPpjPN4+UzXG2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "divider",
    attrs: {
      "id": "FAQSdivider"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e890e026!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AuditionTrialQuestions.vue
// module id = 126
// module chunks = 0